/**
 * @author: lv.chen
 * @date: 2025/11/17
 * @desc: CasualGamesHub/GamesOverlap页面
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import ReusePageTemplate from '@intelligence/v3/components/ReusePageTemplate';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import MobileGamesOverlap from '@intelligence/pages/OverlapAnalysis/MobileGames/content';

interface IGamesOverlapProps extends IBaseProps {}

const GamesOverlap: React.FC<IGamesOverlapProps> = (props) => {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  return (
    <ReusePageTemplate
      style={style}
      className={classnames('dbi-reuse-page-games-overlap', className)}
      title={formatMessage({ id: 'dbi_reuse_page_title_games_overlap' })}
      subTitle={formatMessage({ id: 'dbi_reuse_page_sub_title_games_overlap' })}
    >
      <MarqueeBanner />
      <MobileGamesOverlap
        pageLogConfigKey="casualGamesHubGamesOverlap"
        downloadLogConfigKey="casualGamesHubGamesOverlapDownloadClick"
      />
    </ReusePageTemplate>
  );
};

export default GamesOverlap;
